export default "__VITE_ASSET__UYY7B_Au__"